import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

export const useBookingsUnconfirmMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: bookingsUnconfirmMutation } = useMutation({
		mutationFn: (ids: (number | null)[]) => {
			return axiosPrivate.post(apiRoutes.bookingsUncofirm, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Unconfirmation request succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		bookingsUnconfirmMutation
	}
}
